import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  Textarea,
} from '@chakra-ui/react'
import type { ReactElement } from 'react'
import type { CMFieldProps } from '.'

const CMTextareaField = ({
  cmField,
  disabled,
  isUpload,
  form,
}: CMFieldProps): ReactElement => (
  <FormControl
    marginBottom={isUpload ? 0 : '30px'}
    isInvalid={Boolean(
      form.errors?.upload &&
      form.errors?.upload[cmField.name]
    )}
    isRequired={cmField.schema.isValueRequired}
    isDisabled={disabled}
  >
    <FormLabel>{cmField.label}</FormLabel>
    <Textarea
      resize="vertical"
      type="text"
      value={form?.values?.upload[cmField.name] || ''}
      disabled={disabled}
      readOnly={disabled}
      onChange={e => {
        const value = e.target.value
        if (value.length === 0) {
          form.setFieldValue(`upload.['${cmField.name}']`, null)
        } else {
          form.setFieldValue(`upload.['${cmField.name}']`, value)
        }
      }}
    />
    <FormErrorMessage>
      {form.errors?.upload && form.errors?.upload[cmField.name]}
    </FormErrorMessage>
  </FormControl>
)

export default CMTextareaField
